(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["1"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAllSections() {
      var sections = document.querySelectorAll('.shoppable-video-section');

      sections.forEach(function (section) {
        initSection(section);
      });
    }

    function initSection(section) {
      if (!section || section.dataset.svfInitialized === 'true') {
        return;
      }

      section.dataset.svfInitialized = 'true';

      var modal = section.querySelector('[data-svf-modal]');
      var slides = Array.prototype.slice.call(section.querySelectorAll('[data-svf-slide]'));
      var openButtons = section.querySelectorAll('[data-svf-open]');
      var closeButtons = section.querySelectorAll('[data-svf-close]');
      var prevButton = section.querySelector('[data-svf-prev]');
      var nextButton = section.querySelector('[data-svf-next]');
      var activeIndex = 0;

      function activateSlide(index) {
        if (!slides.length) {
          return;
        }

        activeIndex = (index + slides.length) % slides.length;

        slides.forEach(function (slide, slideIndex) {
          var isActive = slideIndex === activeIndex;
          var video = slide.querySelector('video');
          var iframe = slide.querySelector('iframe');
          var controls = slide.querySelector('[data-svf-slide-controls]');

          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

          if (isActive) {
            // Lazy load slide elements upon activation
            if (video && video.dataset.src) {
              video.src = video.dataset.src;
              video.removeAttribute('data-src');
              video.load();
            }
            if (iframe && iframe.dataset.src) {
              iframe.src = iframe.dataset.src;
              iframe.removeAttribute('data-src');
            }

            // Cross-origin embeds (Instagram) cannot be controlled via custom HTML elements.
            // We cleanly hide controls when displaying an Instagram embed.
            if (iframe && controls) {
              controls.style.display = 'none';
            } else if (controls) {
              controls.style.display = '';
            }

            if (video) {
              video.muted = video.dataset.svfUserUnmuted !== 'true';
              window.requestAnimationFrame(function () {
                fitPopupVideo(video);
              });
              video.play().catch(function () {});
            }
          } else {
            if (video) {
              video.pause();
              video.currentTime = 0;
            }
            // Reset iframe URL on deactivate to instantly kill video background playback & memory usage
            if (iframe && !iframe.dataset.src) {
              iframe.dataset.src = iframe.src;
              iframe.src = 'about:blank';
            }
          }
        });
      }

      function openModal(index) {
        modal.hidden = false;
        document.documentElement.classList.add('svf-modal-open');
        activateSlide(index);

        var closeButton = modal.querySelector('[data-svf-close-button]');
        if (closeButton) {
          closeButton.focus();
        }
      }

      function closeModal() {
        modal.hidden = true;
        document.documentElement.classList.remove('svf-modal-open');

        slides.forEach(function (slide) {
          var video = slide.querySelector('video');
          var iframe = slide.querySelector('iframe');

          if (video) {
            video.pause();
          }
          if (iframe && !iframe.dataset.src) {
            iframe.dataset.src = iframe.src;
            iframe.src = 'about:blank';
          }
        });
      }

      function showNext() {
        activateSlide(activeIndex + 1);
      }

      function showPrevious() {
        activateSlide(activeIndex - 1);
      }

      openButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          openModal(parseInt(button.dataset.svfOpen, 10) || 0);
        });
      });

      closeButtons.forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      if (prevButton) {
        prevButton.addEventListener('click', showPrevious);
      }

      if (nextButton) {
        nextButton.addEventListener('click', showNext);
      }

      document.addEventListener('keydown', function (event) {
        if (modal.hidden) {
          return;
        }

        if (event.key === 'Escape') {
          closeModal();
        }

        if (event.key === 'ArrowRight') {
          showNext();
        }

        if (event.key === 'ArrowLeft') {
          showPrevious();
        }
      });

      initCardControls(section, openModal);
      initSlideControls(section);
    }

    function initCardControls(section, openModal) {
      var controls = section.querySelectorAll('[data-svf-card-controls]');

      controls.forEach(function (controlBar) {
        var card = controlBar.closest('.svf-card');
        var video = card ? card.querySelector('.svf-card__video') : null;
        var playButton = controlBar.querySelector('[data-svf-card-play]');
        var muteButton = controlBar.querySelector('[data-svf-card-mute]');
        var fullscreenButton = controlBar.querySelector('[data-svf-card-fullscreen]');
        var currentTime = controlBar.querySelector('[data-svf-current]');
        var durationTime = controlBar.querySelector('[data-svf-duration]');
        var progress = controlBar.querySelector('[data-svf-progress]');

        if (!video) {
          return;
        }

        function syncPlayState() {
          if (!playButton) {
            return;
          }

          playButton.classList.toggle('is-playing', !video.paused);
          playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }

        function syncMuteState() {
          if (!muteButton) {
            return;
          }

          muteButton.classList.toggle('is-muted', video.muted);
          muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        }

        function syncTime() {
          var duration = Number.isFinite(video.duration) ? video.duration : 0;
          var current = Number.isFinite(video.currentTime) ? video.currentTime : 0;
          var percent = duration > 0 ? Math.min((current / duration) * 100, 100) : 0;

          if (currentTime) {
            currentTime.textContent = formatTime(current);
          }

          if (durationTime) {
            durationTime.textContent = formatTime(duration);
          }

          if (progress) {
            progress.style.width = percent + '%';
          }
        }

        if (playButton) {
          playButton.addEventListener('click', function () {
            if (video.paused) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }

        if (muteButton) {
          muteButton.addEventListener('click', function () {
            video.muted = !video.muted;
            syncMuteState();

            if (video.paused) {
              video.play().catch(function () {});
            }
          });
        }

        if (fullscreenButton) {
          fullscreenButton.addEventListener('click', function () {
            openModal(parseInt(fullscreenButton.dataset.svfCardFullscreen, 10) || 0);
          });
        }

        video.addEventListener('loadedmetadata', syncTime);
        video.addEventListener('durationchange', syncTime);
        video.addEventListener('timeupdate', syncTime);
        video.addEventListener('play', syncPlayState);
        video.addEventListener('pause', syncPlayState);
        video.addEventListener('volumechange', syncMuteState);

        syncPlayState();
        syncMuteState();
        syncTime();
      });
    }

    function initSlideControls(section) {
      var controls = section.querySelectorAll('[data-svf-slide-controls]');

      controls.forEach(function (controlBar) {
        var slide = controlBar.closest('.svf-slide');
        var video = slide ? slide.querySelector('.svf-slide__video') : null;
        var playButton = controlBar.querySelector('[data-svf-slide-play]');
        var muteButton = controlBar.querySelector('[data-svf-slide-mute]');
        var currentTime = controlBar.querySelector('[data-svf-current]');
        var durationTime = controlBar.querySelector('[data-svf-duration]');
        var progress = controlBar.querySelector('[data-svf-progress]');

        if (!video) {
          return;
        }

        function syncFit() {
          fitPopupVideo(video);
        }

        function stopControlEvent(event) {
          event.preventDefault();
          event.stopPropagation();
        }

        function syncPlayState() {
          if (!playButton) {
            return;
          }

          playButton.classList.toggle('is-playing', !video.paused);
          playButton.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        }

        function syncMuteState() {
          if (!muteButton) {
            return;
          }

          muteButton.classList.toggle('is-muted', video.muted);
          muteButton.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        }

        function syncTime() {
          var duration = Number.isFinite(video.duration) ? video.duration : 0;
          var current = Number.isFinite(video.currentTime) ? video.currentTime : 0;
          var percent = duration > 0 ? Math.min((current / duration) * 100, 100) : 0;

          if (currentTime) {
            currentTime.textContent = formatTime(current);
          }

          if (durationTime) {
            durationTime.textContent = formatTime(duration);
          }

          if (progress) {
            progress.style.width = percent + '%';
          }
        }

        if (playButton) {
          playButton.addEventListener('click', function (event) {
            stopControlEvent(event);

            if (video.paused) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        }

        if (muteButton) {
          muteButton.addEventListener('click', function (event) {
            stopControlEvent(event);
            video.muted = !video.muted;
            video.dataset.svfUserUnmuted = video.muted ? 'false' : 'true';
            syncMuteState();

            if (video.paused) {
              video.play().catch(function () {});
            }
          });
        }

        controlBar.addEventListener('click', stopControlEvent);

        video.addEventListener('loadedmetadata', function () {
          syncFit();
          syncTime();
        });
        video.addEventListener('durationchange', syncTime);
        video.addEventListener('timeupdate', syncTime);
        video.addEventListener('play', syncPlayState);
        video.addEventListener('pause', syncPlayState);
        video.addEventListener('volumechange', syncMuteState);
        window.addEventListener('resize', syncFit);

        syncPlayState();
        syncMuteState();
        syncFit();
        syncTime();
      });
    }

    function fitPopupVideo(video) {
      var media = video ? video.closest('.svf-slide__media') : null;
      var mediaStyle;
      var availableWidth;
      var availableHeight;
      var videoRatio;
      var frameRatio;
      var fittedWidth;
      var fittedHeight;

      if (!video || !media || !video.videoWidth || !video.videoHeight) {
        return;
      }

      mediaStyle = window.getComputedStyle(media);
      availableWidth =
        media.clientWidth - parseFloat(mediaStyle.paddingLeft || 0) - parseFloat(mediaStyle.paddingRight || 0);
      availableHeight =
        media.clientHeight - parseFloat(mediaStyle.paddingTop || 0) - parseFloat(mediaStyle.paddingBottom || 0);

      if (availableWidth <= 0 || availableHeight <= 0) {
        return;
      }

      videoRatio = video.videoWidth / video.videoHeight;
      frameRatio = availableWidth / availableHeight;

      if (frameRatio > videoRatio) {
        fittedHeight = availableHeight;
        fittedWidth = fittedHeight * videoRatio;
      } else {
        fittedWidth = availableWidth;
        fittedHeight = fittedWidth / videoRatio;
      }

      video.style.setProperty('width', Math.floor(fittedWidth) + 'px', 'important');
      video.style.setProperty('height', Math.floor(fittedHeight) + 'px', 'important');
      video.style.setProperty('max-width', '100%', 'important');
      video.style.setProperty('max-height', '100%', 'important');
      video.style.setProperty('object-fit', 'contain', 'important');
    }

    function formatTime(seconds) {
      var safeSeconds = Number.isFinite(seconds) ? Math.max(seconds, 0) : 0;
      var minutes = Math.floor(safeSeconds / 60);
      var remainder = Math.floor(safeSeconds % 60).toString();

      if (remainder.length < 2) {
        remainder = '0' + remainder;
      }

      return minutes + ':' + remainder;
    }

    initAllSections();

    document.addEventListener('shopify:section:load', function () {
      initAllSections();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
